// *********************************
// Code generated by sdkgen
// DO NOT EDIT!
//
// Internal module that provides ApiServices to your exposed sdk module.
// *********************************
import { NgModule } from '@angular/core';
import { SessionServiceModule, EnvironmentServiceModule } from '@vendasta/core';
import { ContractBillingApiService } from './contract-billing.api.service';
import { HostService } from '../_generated/host.service';

@NgModule({
  imports: [SessionServiceModule, EnvironmentServiceModule],
  providers: [
    ContractBillingApiService,
      HostService
  ],
  declarations: [],
  exports: [],
  entryComponents: []
})
export class ContractBillingInternalModule {}
